import { render } from "./TopBarPractice.vue?vue&type=template&id=15de98d8&scoped=true&lang=true"
import script from "./TopBarPractice.vue?vue&type=script&lang=js"
export * from "./TopBarPractice.vue?vue&type=script&lang=js"

import "./TopBarPractice.vue?vue&type=style&index=0&id=15de98d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15de98d8"]])

export default __exports__